import { createSelector } from 'reselect';

const getAnalytics = state => state.analytics;

const AnalyticsSelectors = {
    makeCoreProductInvoice: createSelector([getAnalytics], analytics => analytics.coreProductInvoice),
    makePropertiesReport: createSelector([getAnalytics], analytics => analytics.propertiesReport),
    makeBoostAdReport: createSelector([getAnalytics], analytics => analytics.boostAdReport),
    makeBoostAdPreviews: createSelector([getAnalytics], analytics => analytics.boostAdPreviews),
    makeGraphs: createSelector([getAnalytics], analytics => analytics.graphs),
    makeOverviewFilter: createSelector([getAnalytics], analytics => analytics.overviewFilter),
};

export default AnalyticsSelectors;
